// Design Utility Functions

export const getDesign = (dsd, id = null, onLoad = null, onFail = null) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    return dsd.httpConfig.get(`/designs/${id}`, headers)
        .then(response => {
            if (onLoad) {
                onLoad(dataDesign(response.data));
            }
        })
        .catch(e => {
            if (onFail) {
                onFail(e);
            }
        });
};

export const listDesigns = (dsd, Filters = {}, onLoad, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/designs";
    if (Object.keys(Filters).length > 0) {
        urlAPI += "?";
    }

    if (Filters.idUser) {
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.scope) {
        urlAPI += `scope=${encodeURIComponent(Filters.scope)}&`;
    }

    if (Filters.status) {
        urlAPI += `status=${encodeURIComponent(Filters.status)}&`;
    }

    if (Filters.search) {
        urlAPI += `search=${encodeURIComponent(Filters.search)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos = 0; pos < response.data.length; pos++) {
                arr.push(dataDesign(response.data[pos]));
            }
            if (onLoad) {
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
        });
};

export const addDesign = (dsd, Data = {}, onAdd, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadDesign(Data);

    dsd.httpConfig.post('/designs', payload, headers)
        .then(response => {
            if (onAdd) {
                onAdd(response.data._id);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
        });
};

export const editDesign = (dsd, id, Data = {}, onEdit, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadDesign(Data);

    dsd.httpConfig.put(`/designs/${id}`, payload, headers)
        .then(response => {
            if (onEdit) {
                onEdit(response.data);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
        });
};

// DesignItem functions
export const addDesignItemToDesign = (dsd, idDesign, Data = {}, onAdd, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadDesignItem(Data);

    dsd.httpConfig.post(`/designs/${idDesign}/designitems`, payload, headers)
        .then(response => {
            if (onAdd) {
                onAdd(response.data._id);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
        });
};

export const editDesignItem = (dsd, idDesignItem, Data = {}, onEdit, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadDesignItem(Data);

    dsd.httpConfig.put(`/designitems/${idDesignItem}`, payload, headers)
        .then(response => {
            if (onEdit) {
                onEdit(response.data);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
        });
};

export const getDesignItem = (dsd, idDesignItem, onLoad, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    dsd.httpConfig.get(`/designitems/${idDesignItem}`, headers)
        .then(response => {
            if (onLoad) {
                onLoad(response.data);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
        });
};

export const getDesignVersion = (dsd, id = null, idVersion = null, onLoad = null, onFail = null, format = "dsd") => {

    let headers = {
        headers: 
            {
                "Content-type": "application/json"
            }
        }

    let authHeader = dsd.authHeader();

    if (authHeader){
        headers.headers.Authorization = authHeader.Authorization;
    }

    let URL = `/designs/${id}/version/${idVersion}?`
    if (format){
        URL += `&format=${format}`;
    }

    return(                
        dsd.httpConfig.get(URL, headers)
        .then(response => {
            if (onLoad){
                if (format && format.toLowerCase() !== 'dsd'){
                    onLoad(response.data);
                } else {
                    onLoad(dataDesign(response.data));
                }
            }
        })
        .catch(e => {
            if (onFail){
                onFail(e)
            }
        })
    );
};

// Helper functions
function dataDesign(data) {
    let obj = data;
    return obj;
}

function payloadDesign(Data) {
    let payload = {
        name: Data.name,
        description: Data.description,
        status: Data.status
    };
    return payload;
}

function payloadDesignItem(Data) {
    let payload = {
        name: Data.name,
        reference: Data.reference,
        definition: Data.definition,
        sources: Data.sources,
        rules: Data.rules,
        resources: Data.resources,
        alternatives: Data.alternatives,
        stakeholders: Data.stakeholders,
        law: Data.law,
        standards: Data.standards,
        status: Data.status,
        seq: Data.seq
    };
    return payload;
}
